const DEFAULT_COUNTRY = 'ROW';
const PAYMENT_METHODS_BY_COUNTRY = {
  ROW: ['visa', 'mastercard', 'amex', 'unionpay', 'diners'],
  BR: ['visa', 'mastercard', 'amex', 'boleto', 'elo'],
  FR: ['visa', 'mastercard', 'amex', 'diners'],
  LV: ['visa', 'mastercard', 'amex', 'diners'],
  SI: ['visa', 'mastercard', 'amex', 'diners'],
  PT: ['visa', 'mastercard', 'amex', 'diners'],
  IT: ['visa', 'mastercard', 'amex', 'diners'],
  NL: ['visa', 'mastercard', 'amex', 'diners'],
  DE: ['visa', 'mastercard', 'amex', 'diners'],
  CY: ['visa', 'mastercard', 'amex', 'diners'],
  AT: ['visa', 'mastercard', 'amex', 'diners'],
  SK: ['visa', 'mastercard', 'amex', 'diners'],
  ES: ['visa', 'mastercard', 'amex', 'diners'],
  IE: ['visa', 'mastercard', 'amex', 'diners'],
  BE: ['visa', 'mastercard', 'amex', 'diners'],
  LU: ['visa', 'mastercard', 'amex', 'diners'],
  FI: ['visa', 'mastercard', 'amex', 'diners'],
  EE: ['visa', 'mastercard', 'amex', 'diners'],
  LT: ['visa', 'mastercard', 'amex', 'diners'],
  IN: ['visa', 'mastercard', 'amex', 'payu'],
  IL: ['visa', 'mastercard', 'amex', 'diners'],
  JP: ['visa', 'mastercard', 'amex', 'jcb', 'diners'],
  US: ['visa', 'mastercard', 'amex', 'discover']
};
export const getLocalePaymentMethods = geo => {
  const country = geo == null ? void 0 : geo.toUpperCase();
  const validCountry = country && country in PAYMENT_METHODS_BY_COUNTRY ? country : DEFAULT_COUNTRY;
  return PAYMENT_METHODS_BY_COUNTRY[validCountry];
};
//# sourceMappingURL=getLocalePaymentMethods.js.map